
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useAuth } from '@/contexts/AuthContext';
import ThreeAssistant from '@/components/assistant/ThreeAssistant';

const ChatPopup: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const { isAuthenticated } = useAuth();
  
  // Check if we're on the chat page
  const isOnChatPage = location.pathname === '/chat';
  
  const handleChatClick = () => {
    // Use React Router's navigate instead of directly manipulating DOM
    navigate('/chat');
  };

  // Don't render the chat popup on the chat page
  if (isOnChatPage) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 flex items-center gap-2">
      {/* Text bubble - with typing animation that stops after completion */}
      <div 
        className={cn(
          "bg-white text-primary font-medium shadow-soft rounded-xl px-4 py-2",
          "text-sm md:text-base"
        )}
      >
        <span className="typing-animation-once">Chat with your AI Career Agent</span>
      </div>
      
      <div 
        className="h-18 w-18 relative cursor-pointer" 
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleChatClick}
        aria-label="Open Career Chat"
      >
        <ThreeAssistant 
          isResponding={isHovered}
          hideSelector={true}
          hideForm={true}
          assistantType="futuristicBall"
          containerSize={72} // Increased by 50% from 48 to 72
          hideRespondingLabel={true}
        />
      </div>
    </div>
  );
};

export default ChatPopup;
